module.exports = __webpack_public_path__ + "media/images/products/template/01/04-b71de995b4087f10a87e77c4b1d4dd29.jpg";